export function isCategoriesFilterTabVisible(categories) {
    return categories.length > 0;
}
